import {Slide, Snackbar, Theme} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {amber, green} from "@mui/material/colors";
import {connect, MapStateToProps} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {hideNotification} from "../actions";
import {Notification} from "../types";
import {SlideProps} from "@mui/material/Slide";
import {FormattedMessage} from "react-intl";
import {CheckCircleIcon, CloseIcon, ErrorIcon, InfoIcon, WarningIcon} from "../components/icons";
import {RootState} from "@/store";

type StateProps = {
    notification: Notification;
};

type DispatchProps = {
    hideNotification: () => void;
};

const mapStateToProps: MapStateToProps<StateProps, Record<string, never>, RootState> = (store: RootState) => ({
    notification: store.notification,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({hideNotification}, dispatch);

const useStyles = makeStyles()((theme: Theme) => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    warning: {
        backgroundColor: amber[700],
    },
    content: {
        display: "flex",
        alignItems: "center",
        color: "white",
    },
    snackContent: {
        "& > div": {
            width: "100%",
        },
    },
    icon: {
        fontSize: 20,
        marginRight: theme.spacing(1),
    },
}));

type Props = StateProps & DispatchProps;

const variantIcon: {[s: string]: any} = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)((props: Props) => {
    const {notification} = props;
    const {classes} = useStyles();

    function Message({data: {message, variant, messageVars}}: {data: Notification}) {
        const Icon = variantIcon[variant];
        return (
            <div className={classes.content}>
                <Icon className={classes.icon} />
                <span style={{flexGrow: 1, paddingRight: "1em"}}>
                    <FormattedMessage {...message} values={messageVars} />
                </span>
                <CloseIcon onClick={props.hideNotification} style={{cursor: "pointer"}} />
            </div>
        );
    }

    return (
        <Snackbar
            anchorOrigin={{vertical: "top", horizontal: "right"}}
            open={notification.show}
            autoHideDuration={notification.autoHideDuration}
            onClose={(_, reason) => {
                if (reason === "clickaway") {
                    return;
                }
                props.hideNotification();
            }}
            TransitionComponent={SlideTransition}
            ContentProps={{className: `${classes[notification.variant]} ${classes.snackContent}`}}
            message={<Message data={notification} />}
        />
    );
});
